import { css } from '@emotion/react'
import { alpha, Theme } from '@mui/material/styles'

export const sliderContainer = ({
  track,
  theme,
  orientation,
}: {
  track: 'normal' | 'inverted' | false
  theme: Theme
  orientation?: 'vertical' | 'horizontal'
}) => css`
  position: relative;
  margin-top: ${theme.spacing(-2)};
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${orientation === 'horizontal' && '100%'};
  height: ${orientation === 'vertical' && '100%'};
  margin-bottom: ${theme.spacing(-2)};
  & .MuiSlider-root {
    padding-top: ${theme.spacing(5)};
  }

  & .MuiSlider-mark {
    display: none;
  }

  & .MuiSlider-rail,
  .MuiSlider-track {
    height: ${orientation === 'horizontal' && '8px'};
    width: ${orientation === 'vertical' && '8px'};
  }

  & .MuiSlider-rail {
    background-color: ${track ? theme.palette.grey[500] : theme.palette.primary.main + '80'};
  }

  & .MuiSlider-thumb {
    height: 18px;
    width: 18px;
    box-shadow: none;

    &::before {
      opacity: 0;
    }
  }

  & .MuiSlider-valueLabel {
    color: ${theme.palette.primary.main};
    background-color: transparent;
    transform: translateY(100%) !important;
    top: 4px;
    padding: 0;
    font-size: 14px !important;
    font-weight: 800;
    padding: 0 16px;
    transition: none !important;
  }
`

export const sliderWithIndicators = ({
  orientation,
}: {
  orientation?: 'vertical' | 'horizontal'
}) => css`
  & .MuiSlider-thumb::after {
    width: 32px;
    height: 32px;
  }

  & .MuiSlider-markLabel {
    top: ${orientation === 'horizontal' && '-15px'};
    left: ${orientation === 'vertical' && '-36px'};
  }
`

export const indicatorsContainer = css`
  position: absolute;

  left: 0px;
  right: 0px;
  top: 0;
  bottom: 0;
`

export const indicatorContainer = ({ indicatorXPosition }: { indicatorXPosition: number }) => css`
  position: absolute;
  left: calc(${indicatorXPosition}%);
  top: 40px;
`

export const triangleTick = () => css`
  position: absolute;
  top: -1px;
  transform: scaleX(1.2);

  &.MuiTypography-root {
    font-size: 13px !important;
  }
`

export const tickValue = ({
  theme,
  disabled,
  isSelected,
  useTriangleTicks,
  show,
}: {
  theme: Theme
  disabled?: boolean
  isSelected?: boolean
  useTriangleTicks?: boolean
  show: boolean
}) => {
  const color = isSelected ? theme.palette.primary.main : theme.palette.text.primary

  return css`
    position: absolute;
    top: ${useTriangleTicks ? '16px' : '10px'};
    left: 0;
    transform: translate(-50%, 0);
    color: ${disabled ? alpha(theme.palette.text.disabled, 0.5) : color};
    &.MuiTypography-root {
      font-size: 14px !important;
      font-weight: ${isSelected ? 700 : 400} !important;
    }
    opacity: ${show ? '1' : '0'};
    transition:
      opacity 0.1s ease-in-out,
      transform 0.1s ease-in-out;
  `
}

export const tickContainer = css`
  position: absolute;
  display: flex;
  align-items: center;
  flex-direction: column;
  top: -11px;
`

export const circleTick = ({ theme, disabled }: { theme: Theme; disabled?: boolean }) => css`
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: 4px solid ${disabled ? theme.palette.text.disabled : theme.palette.primary.main};
  background-color: ${theme.palette.background.paper};
`
